<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Form

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">



                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-tg-auto">
                        <label for="diaplayName"><span>*</span> Form</label>
                      </div>

                      <div class="col-md-7">
                        <CustomDataByRequestType RequestedType="FDTemplateByActorReportCode" ActorCode='{{ActorCode}}'
                                                 id="CurrentSaveClinicalFormRequest.FormCode" SelectedValue="CurrentSaveClinicalFormRequest.FormCode"
                                                 [(ngModel)]="CurrentSaveClinicalFormRequest.FormCode" (keyChange)="onAssignedToActorCodeForms($event)"
                                                 name="CurrentSaveClinicalFormRequest.FormCode" required>
                        </CustomDataByRequestType>
                        <!--<CodeTypeValue CodeType="RELTP"
                                       id="CurrentActorAddEmergencyInfoRequest.RelationType"
                                       [(ngModel)]="CurrentActorAddEmergencyInfoRequest.RelationType" SelectedValue=""
                                       name="CurrentActorAddEmergencyInfoRequest.RelationType">
                        </CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                        <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                               name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-tg-auto">
                        <label for="firstName"> Date</label>
                      </div>
                      <div class="col-md-4">
                        <div class="date-form">
                          <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="Date" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                          <a (click)="d1.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-tg-auto">
                        <label for="diaplayName"><span>*</span> Doctor </label>
                      </div>
                      <div class="col-md-4">
                        <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                 id="CurrentSaveClinicalFormRequest.Provider1Code" SelectedValue="CurrentSaveClinicalFormRequest.Provider1Code"
                                                 [(ngModel)]="CurrentSaveClinicalFormRequest.Provider1Code" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                 name="CurrentSaveClinicalFormRequest.Provider1Code" required>
                        </CustomDataByRequestType>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-tg-auto">
                        <label for="diaplayName">Assistant </label>
                      </div>
                      <div class="col-md-4 ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                        <!--id="CurrentActorPersonalDetailInfoRequest.City"
                               [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                               name="CurrentActorPersonalDetailInfoRequest.City"
                                maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                        <small class="form-text text-danger"
                               *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<label>Hyderabad</label>-->
                        <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                 id="CurrentSaveClinicalFormRequest.Provider2Code" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveClinicalFormRequest.Provider2Code" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                 name="CurrentSaveClinicalFormRequest.Provider2Code">
                        </CustomDataByRequestType>
                      </div>
                    </div>


                  </div>
                </div>




              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
